const stringFilters = [
	{
		value: 'like',
		label: 'Contains'
	},
	{
		value: 'is',
		label: 'Is'
	},
	{
		value: 'is_not',
		label: 'Is not'
	},
	{
		value: 'not_like',
		label: 'Does not contain'
	},
	{
		value: 'like_start',
		label: 'Starts with'
	},
	{
		value: 'like_end',
		label: 'Ends with'
	},
	{
		value: 'is_empty',
		label: 'Is Empty'
	},
	{
		value: 'is_not_empty',
		label: 'Is not empty'
	}
];

const dateFilters = [
	{
		value: 'is',
		label: 'Is',
		controll: 'date'
	},
	{
		value: 'is_before',
		label: 'Is Before',
		controll: 'date'
	},
	{
		value: 'is_on_or_before',
		label: 'Is on or before',
		controll: 'date'
	},
	{
		value: 'is_on_or_after',
		label: 'Is on or after',
		controll: 'date'
	},
	{
		value: 'is_between',
		label: 'Is Between',
		controll: 'date_range'
	},
	{
		value: 'is_empty',
		label: 'Is Empty'
	},
	{
		value: 'is_not_empty',
		label: 'Is not empty'
	}
];

const numberFilters = [
	{
		value: 'is_equal',
		label: 'Equal To'
	},
	{
		value: 'is_greater_than',
		label: 'Greater than'
	},
	{
		value: 'is_less_than',
		label: 'Less than'
	},
]

export function columns() {
	return [
		{
			key: 'branch_name_en',
			label: "branchName",
			type: 'text',
			filters: undefined
		},
		{
			key: 'payment_date',
			label: "invoiceDate",
			type: 'date',
			filters: undefined
		},
		{
			key: 'invoice_number',
			type: 'text',
			filters: stringFilters,
			label: "receiptNumber"
		},
		{
			key: 'student_name',
			type: 'text',
			filters: stringFilters,
			label: "studentName"
		},
		{
			key: 'fee_name_en',
			type: 'text',
			filters: stringFilters,
			label: "serviceName"
		},
		{
			key: 'fee_start_date',
			type: 'date',
			filters: dateFilters,
			label: "startDate"
		},
		{
			key: 'fee_end_date',
			type: 'date',
			filters: dateFilters,
			label: "nextPaymentDate"
		},
		{
			key: 'quantity',
			type: 'number',
			filters: numberFilters,
			label: "unit",
			className: 'ts-text-center'
		},
		{
			key: 'price',
			type: 'number',
			filters: numberFilters,
			label: "price",
			className: 'ts-text-right'
		},
		{
			key: 'amount',
			type: 'number',
			filters: numberFilters,
			label: "amount",
			className: 'ts-text-right'
		},
		{
			slot: 'discount',
			col: 'discount_rate',
			type: 'number',
			filters: numberFilters,
			label: "discount",
			className: 'ts-text-right'
		},
		{
			key: 'total_amount',
			type: 'number',
			filters: numberFilters,
			label: "total_amount",
			className: 'ts-text-right'
		},
		{
			key: 'payment_method',
			type: 'text',
			filters: undefined,
			label: "paymentMethod"
		},
		{
			key: 'created_name',
			type: 'text',
			filters: stringFilters,
			label: "createdBy"
		}
	]
}
